import { FC } from 'react';
import { Link } from 'react-router-dom';

import { ArrowLeftOutline, Button, HStack } from '../../design-system/design-system';

type BackLinkProps = {
	children: string;
	to: string;
};

export const BackLink: FC<BackLinkProps> = ({ children, to }) => {
	return (
		<HStack>
			<Button as={Link} variant="link" gap={1} to={to} type="button">
				<ArrowLeftOutline size="xs" />
				{children}
			</Button>
		</HStack>
	);
};
